import React, { Component } from 'react';
import styled from 'styled-components';
import { NavLink, Link } from 'react-router-dom';

const Logo = styled(Link)`
  text-decoration: none;
  color: #FFFFFF !important;
  font-size: 30px !important;
  margin-top: 1em;
  margin-left: 0.5em;
`;

class Sidebar extends Component {
  state = {
    active: 'dashboard'
  }

  setActive = (active) => {
    this.setState({ active, });
  }

  render() {
    const { logout } = this.props;
    const { active } = this.state;
    return (
      <div id='sidebar-wrapper'>
        <ul className='sidebar-nav'>
          <li className='sidebar-brand'>
            <Logo to='/' className='text-white logo'>
              cloudchefs
            </Logo>
          </li>
          <li className='nav-item'>
            <NavLink
              className={active === 'dashboard' ? 'nav-link text-white' : 'nav-link'}
              to='/'
              onClick={() => this.setActive('dashboard')}
            >
              Dashboard
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink
              className={active === 'orders' ? 'nav-link text-white' : 'nav-link'}
              to='/orders'
              onClick={() => this.setActive('orders')}
            >
              Orders
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink
              className={active === 'partners' ? 'nav-link text-white' : 'nav-link'}
              to='/delivery-partners'
              onClick={() => this.setActive('partners')}
            >
              Delivery Partners
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink
              className={active === 'customers' ? 'nav-link text-white' : 'nav-link'}
              to='/customers'
              onClick={() => this.setActive('customers')}
            >
              Customers
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink
              className={active === 'shops' ? 'nav-link text-white' : 'nav-link'}
              to='/shops'
              onClick={() => this.setActive('shops')}
            >
              Shops
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink
              className={active === 'managers' ? 'nav-link text-white' : 'nav-link'}
              to='/managers'
              onClick={() => this.setActive('managers')}
            >
              Shop Managers
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink
              className={active === 'leads' ? 'nav-link text-white' : 'nav-link'}
              to='/leads'
              onClick={() => this.setActive('leads')}
            >
              Shop Leads
            </NavLink>
          </li>
          <li className='nav-item'>
            <button className='btn btn-link text-muted' onClick={() => logout()}>Sign out</button>
          </li>
        </ul>
      </div>
    );
  }
}

export default Sidebar;